import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Draggable from 'react-draggable';
import Modal from '../../../components/modal';
import Button from '../../../components/button';
import { importAllImages } from '../../../utils/helpers';
import styles from './location.module.scss';
import info from '../../../icons/edit.svg';
import Clickable from '../../../components/clickable/Clickable';

class PictureDraggable extends React.Component {
  state = {
    width: 1000,
    height: 500
  };

  myImg = React.createRef();

  scrollRef = React.createRef();

  images = importAllImages(
    require.context(
      '../../../icons/non_airfield_location_icons',
      false,
      /\.(png|jpe?g|svg)$/
    )
  );

  handleStop = (e, d) => {
    const { handleAnswerChanged, attachment } = this.props;
    if (handleAnswerChanged) {
      handleAnswerChanged('info', { x: d.x, y: d.y }, 'location_marked');
      handleAnswerChanged('info', attachment.id, 'location_attachment');
    }
  };

  handleCancel = () => {
    const {
      handleAnswerChanged,
      attachment,
      handleDisplay,
      savedPoint,
      position,
      savedStatus
    } = this.props;
    if (handleAnswerChanged) {
      if (!position && !savedPoint) {
        handleAnswerChanged('info', { x: 0, y: 0 }, 'location_marked');
      } else if (savedPoint) {
        handleAnswerChanged('info', savedPoint, 'location_marked');
      } else if (position && !savedStatus) {
        handleAnswerChanged('info', { x: 0, y: 0 }, 'location_marked');
      }
      handleAnswerChanged('info', attachment.id, 'location_attachment');
      handleDisplay();
    }
  };

  handleSize = (image) => {
    const { fromSMS, nawo, maintenenceDetails } = this.props;
    let width = image.naturalWidth;
    let height = image.naturalHeight;
    if (fromSMS) {
      width = 736;
      height = 647;
    } else if (width > 3000) {
      width /= 5;
      height /= 5;
    } else if (width > 1900) {
      width /= 2;
      height /= 2;
    } else if (height > 800) {
      width /= 2;
      height = 600;
    }
    this.setState({ width, height });
    if (nawo || maintenenceDetails) {
      this.scrollToPosition();
    }
  };

  getDetailCode = () => {
    const { position, attachment, nawo, maintenenceDetails } = this.props;
    const { width, height } = this.state;
    let icon = 'location_red.png';
    const pos = typeof position === 'string' ? JSON.parse(position) : position;
    return (
      <>
        <Draggable
          axis="both"
          handle=".handle"
          positionOffset={{ x: pos.x, y: pos.y }}
          scale={1}
          disabled
          onStop={this.handleStop}
          bounds={{ top: 0, left: 0 }}
        >
          <div
            style={
              nawo || maintenenceDetails
                ? { width: '40px' }
                : { position: 'absolute' }
            }
          >
            <div className="handle">
              <img
                src={this.images[icon].default}
                alt="Custom_location"
                width={40}
              />
            </div>
          </div>
        </Draggable>
        <img
          src={attachment && attachment.url}
          alt={attachment && attachment.file_name}
          ref={this.myImg}
          width={width}
          height={height}
          id="myImg"
          onLoad={() => this.handleSize(this.myImg.current)}
          style={nawo || maintenenceDetails ? { marginTop: '-43.9px' } : {}}
        />
      </>
    );
  };

  getChangeCode = () => {
    const {
      fromSMS,
      position,
      attachment,
      nawo,
      maintenenceDetails,
      responsiveScroll
    } = this.props;
    const { height, width } = this.state;
    let icon = 'location_red.png';

  return (
  <>
    <div
      style={
        nawo || maintenenceDetails
          ? { marginTop: '-43.9px' }
          : { overflow: width > 500 ? 'auto' : '' }
      }
    >
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <Draggable
          axis="both"
          handle=".handle"
          disabled={fromSMS}
          bounds="parent"
          position={{
            x: position && Object.keys(position).length > 0 ? position.x : 0,
            y: position && Object.keys(position).length > 0 ? position.y : 0
          }}
          scale={1}
          onStop={this.handleStop}
        >
          <div
            style={
              nawo || maintenenceDetails
                ? { width: '40px' }
                : { position: 'absolute', zIndex: 10 }
            }
          >
            <div className="handle">
              <img
                src={this.images[icon].default}
                alt="Custom_location"
                width={40}
              />
            </div>
          </div>
        </Draggable>
        <Clickable onClick={fromSMS ? this.handleClick : ''}>
          <img
            src={attachment && attachment.url}
            alt={attachment && attachment.file_name}
            ref={this.myImg}
            width={width}
            height={fromSMS ? height - 100 : height}
            id="myImg"
            onLoad={() => this.handleSize(this.myImg.current)}
          />
        </Clickable>
      </div>
    </div>
        {fromSMS && !responsiveScroll && (
      <div className={styles.alert}>
        <img src={info} alt="info" style={{ marginRight: '8px' }} />
        Pin a marker to indicate the discrepancy location
      </div>
    )}
  </>
  );
  };

  handleClick = (e) => {
    const bounds = e.currentTarget.getBoundingClientRect(); // Use currentTarget instead of target
    const x = e.pageX - window.scrollX - bounds.left; // Adjust for scroll position
    const y = e.pageY - window.scrollY - bounds.top; // Adjust for scroll position
    this.handleStop(undefined, { x: x - 10, y: y - 10 });
  };

  scrollToPosition = () => {
    const { position } = this.props;
    const scrollElement = this.scrollRef.current;

    if (
      scrollElement
      && (scrollElement.clientWidth / 2 < position?.x
        || scrollElement.clientHeight / 2 < position?.y)
    ) {
      const centerX = position?.x - scrollElement.clientWidth / 2;
      const centerY = position?.y - scrollElement.clientHeight / 2;

      setTimeout(() => {
        scrollElement.scrollTo({
          top: Math.abs(centerY),
          left: Math.abs(centerX),
          behavior: 'auto'
        });
      }, 100);
    }
  };

  render() {
    const { width, height } = this.state;
    const {
      attachment,
      detail,
      position,
      location,
      display,
      handleDisplay,
      user,
      locDetail,
      fromSMS,
      handleSave,
      nawo,
      maintenenceDetails,
      responsiveScroll
    } = this.props;
    let icon = 'location_red.png';
    if (user && user.airport_settings && user.airport_settings.nwo_icon) {
      icon = user.airport_settings.nwo_icon;
    }
    return (
      <>
        {locDetail && fromSMS ? (
          <div>
            <Draggable
              axis="both"
              handle=".handle"
              positionOffset={{ x: position?.x, y: position?.y }}
              scale={1}
              onStop={this.handleStop}
              disabled
              bounds={{ top: 0, left: 0 }}
            >
              <div style={{ position: 'absolute' }}>
                <div className="handle">
                  {position?.x !== 0 && (
                    <img
                      src={this.images[icon].default}
                      alt="Custom_location"
                      width={40}
                    />
                  )}
                </div>
              </div>
            </Draggable>
            <img
              src={attachment && attachment.url}
              alt={attachment && attachment.file_name}
              ref={this.myImg}
              width={width}
              height={height - 100}
              id="myImg"
              onLoad={() => this.handleSize(this.myImg.current)}
            />
          </div>
        ) : (
          <Modal
            showIn={display}
            width={
              nawo || maintenenceDetails
                ? `${width > 1527 ? '80%' : `${width < 700 ? 700 : width}px`}`
                : window.screen.availWidth - 100
            }
            height={window.screen.availHeight - 100}
            onClose={handleDisplay}
            contentStyles={{
              minHeight: 'fit-Content',
              maxWidth: window.screen.availWidth - 100,
              maxHeight: window.screen.availHeight - 100
            }}
          >
            <div>
              <div
                className={`${styles.header} ${
                  !detail && (fromSMS || nawo || maintenenceDetails)
                    ? styles.modalHeader
                    : ''
                }`}
                style={detail && nawo ? { padding: '20px' } : {}}
              >
                 {detail ? (
                  <FormattedMessage
                    id="maintenance.custom_location.indoor_map_detail"
                    defaultMessage=" {locationName} Map"
                    values={{ locationName: location }}
                  />
                ) : (
                  <div className={fromSMS || nawo ? styles.locModalHeader : ''}>
                    <FormattedMessage
                      id="maintenance.custom_location.indoor_map_create"
                      defaultMessage="Outdoor Location {locationName} Map ( drag and drop the pin to indicate the discrepancy location)"
                      values={{ locationName: location }}
                    />
                  </div>
                )}
                <button
                  onClick={detail ? handleDisplay : this.handleCancel}
                  type="button"
                  className={`${styles.button} ${
                    !detail && (fromSMS || nawo) ? styles.closeButton : ''
                  }`}
                >
                  &times;
                </button>
              </div>
              {detail ? (
                <>
                  <div
                    ref={this.scrollRef}
                    style={
                      nawo || maintenenceDetails
                        ? {
                            width,
                            maxWidth: '100%',
                            height,
                            maxHeight: '600px',
                            overflow: `${
                              width > 1527 || height > 600 ? 'auto' : ''
                            }`
                          }
                        : { width, height }
                    }
                    className={fromSMS ? styles.modalStyle : ''}
                  >
                    {nawo || maintenenceDetails ? (
                      <div style={{ width, height, maxHeight: '600px' }}>
                        {this.getDetailCode()}
                      </div>
                    ) : (
                      <>{this.getDetailCode()}</>
                    )}
                  </div>
                </>
              ) : (
                <>
                  {(() => {
                    let scrollStyle = { width, height, marginTop: '30px' };
                    if (nawo || maintenenceDetails) {
                      scrollStyle = {
                        width,
                        maxWidth: '100%',
                        height,
                        maxHeight: '600px',
                        overflow: `${width > 1527 || height > 600 ? 'auto' : ''}`
                      };
                    } else if (responsiveScroll) {
                      scrollStyle = { maxHeight: '60vh',
                      overflow: 'auto',
                      marginTop: '10px',
                      position: 'relative',
                      display: 'inline-block',
                      width: '100%' };
                    }

                    let innerContent = <>{this.getChangeCode()}</>;
                    if (nawo || maintenenceDetails) {
                      innerContent = (
                        <div style={{ width, height, maxHeight: '600px' }}>
                          {this.getChangeCode()}
                        </div>
                      );
                    } else if (responsiveScroll) {
                      innerContent = (
                        <div style={{ width }}>{this.getChangeCode()}</div>
                      );
                    }
                    return (
                      <div
                        ref={this.scrollRef}
                        style={scrollStyle}
                        className={fromSMS ? styles.modalStyle : ''}
                      >
                        {innerContent}
                      </div>
                    );
                  })()}
                  {responsiveScroll && (
                    <div className={styles.smsAlert}>
                      <img src={info} alt="info" style={{ marginRight: '8px' }} />
                      Pin a marker to indicate the discrepancy location
                    </div>
                  )}
                  <div className={styles.footer}>
                    <Button
                      onClick={this.handleCancel}
                      translationID="todo.newTask.cancel"
                      defaultText="Cancel"
                      action="teritary"
                      className={styles.closeButton}
                    />
                    <Button
                      onClick={(nawo && handleDisplay) || handleSave}
                      translationID={
                        fromSMS ? 'documents.done' : 'todo.newTask.save1'
                      }
                      defaultText={fromSMS ? 'Done' : 'Save'}
                      action="secondary"
                      className={styles.saveButton}
                    />
                  </div>
                </>
              )}
            </div>
          </Modal>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.profile
});

export default connect(mapStateToProps)(PictureDraggable);
